import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { styled } from "@mui/material/styles";
import { useFetchPrincipalEntitiesdataQuery } from "../../../../store/services/principleApi";
import { useFetchHeadersByPrincipalIdQuery } from "../../../../store/services/headerApi ";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { formatedCurrentDateTime } from "../../../../utility/GetCurrentDateTime";
import api from "../../../../Appjs/api";
import {
  useUploadComposeSMSMutation,
  useLazyCheckSpamKeywordsQuery,
  usePreviewcomposeDataMutation,
} from "../../../../store/services/smsApi";
import { useGetTemplateByPrincipalIdQuery } from "../../../../store/services/templateApi";
import { io } from "socket.io-client";
import socketApi from "../../../../Appjs/socketApi";
import { useGetCustomerCountriesQuery } from "../../../../store/services/blacklistApi";
import {
  useCheckMpinStatusQuery,
  useVerifyMpinStatusMutation,
} from "../../../../store/services/userApi";
import Loader from "../../../common/Loader";
import { maskNumber } from "../../../common/Encryption";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

// ── Shared sizing tokens (same as BulkSMS) ───────────────────────────────────
const FIELD_HEIGHT = 35;
const FORM_MAX_WIDTH = 510;

// Shows first 3 + "..." + last 3 characters
const trimPeId = (id) => {
  const str = String(id ?? "");
  if (str.length <= 6) return str;
  return `${str.slice(0, 3)}...${str.slice(-3)}`;
};

// Tighter dropdown options (matches BulkSMS)
const compactMenuProps = {
  PaperProps: {
    sx: {
      "& .MuiMenuItem-root": {
        minHeight: 28,
        py: 0.25,
        px: 1.5,
        fontSize: "0.8rem",
      },
    },
  },
  MenuListProps: { dense: true, sx: { py: 0.5 } },
};

// ── Shared glass token (matches BulkSMS) ─────────────────────────────────────
const glassField = {
  height: FIELD_HEIGHT,
  fontSize: "0.8rem",
  background: "rgba(255,255,255,0.7)",
  backdropFilter: "blur(8px)",
  borderRadius: "8px",
  "&:hover": { boxShadow: "0 4px 12px rgba(0,0,0,0.05)" },
};

const Compose = ({ service_id, onPreviewChange }) => {
  // ── ALL STATE UNCHANGED ───────────────────────────────────────────────────
  const [socket, setSocket] = useState(null);
  const [smsType, setSmsType] = useState(() => {
    return localStorage.getItem("smsType") || "english";
  });
  const [isSubmit, setIsSubmit] = useState(false);
  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const [reviewData, setReviewData] = useState(null);
  const [smstext, setSmsText] = useState("");
  const [charCountState, setCharCountState] = useState(0);
  const [smsCountState, setSmsCountState] = useState(0);
  const [templateId, setTemplateId] = useState("");
  const [showSpamWarning, setShowSpamWarning] = useState(false);
  const [spamKeywords, setSpamKeywords] = useState([]);
  const [peId, setPeId] = useState("");
  const [isAllow, setIsAllow] = useState(false);
  const [countdownTimer, setCountdownTimer] = useState(null);
  const [fileNames, setFileNames] = useState("");
  const [filterDatatill_days, setFilterDatatill_days] = useState('');
  const [file, setFile] = useState(null);
  const [phoneNumbers, setPhoneNumbers] = useState("");
  const [entityId, setEntityId] = useState(null);
  const [prId, setPrId] = useState(null);
  const [isPrincipalEntitySelected, setIsPrincipalEntitySelected] = useState(false);
  const [headers, setHeaders] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [enableFilterTill, setEnableFilterTill] = React.useState(false);
  const [principalEntities, setPrincipalEntities] = useState([]);
  const [headerName, setHeaderName] = useState("");
  const [selectedTemplateName, setSelectedTemplateName] = useState("");
  const [isTransliterationEnabled, setIsTransliterationEnabled] = useState(false);
  const [transliterationControl, setTransliterationControl] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [isLongMessageWarning, setIsLongMessageWarning] = useState(false);
  const [alertShown, setAlertShown] = useState(false);
  const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false);
  const [templateSearch, setTemplateSearch] = useState("");
  const [isFlash, setIsFlash] = useState(false);
  const [enableSchedule, setEnableSchedule] = useState(false);
  const [smsCount, setSmsCount] = useState(1);
  const [charCount, setCharCount] = useState(0);
  const [postVia, setPostVia] = useState("");
  const [isCountryModalOpen, setIsCountryModalOpen] = useState(false);
  const [isCountrySelected, setIsCountrySelected] = useState(true);
  const [currentLanguage, setCurrentLanguage] = useState("hi");
  const [dateTime, setDateTime] = useState(dayjs(new Date()).format("YYYY-MM-DDTHH:mm"));
  const [sendTime, setSendTime] = useState(
    enableSchedule ? dayjs(dateTime).format("YYYY-MM-DD HH:mm") : dayjs(new Date()).format("YYYY-MM-DD HH:mm")
  );
  const [minDateTime, setMinDateTime] = useState(dayjs().format("YYYY-MM-DDTHH:mm"));
  const [selectedCountry, setSelectedCountry] = useState({ id: 1, name: "India", code: "+91" });
  const [previewComposeData, { isLoading: isPreviewLoading }] = usePreviewcomposeDataMutation();
  const [mpinModalOpen, setMpinModalOpen] = useState(false);
  const [mpin, setMpin] = useState("");
  const [mpinError, setMpinError] = useState("");
  const [isSubmittingAfterMpin, setIsSubmittingAfterMpin] = useState(false);
  const [filterMobileNumber, setfilterMobileNumber] = useState("");

  // ── ALL HOOKS UNCHANGED ───────────────────────────────────────────────────
  const { data: headersData, isLoading: headersLoading, isError: headersError } =
    useFetchHeadersByPrincipalIdQuery(prId, { skip: !prId, refetchOnMountOrArgChange: true });
  const { data: principalEntitiesData, isLoading, isError } = useFetchPrincipalEntitiesdataQuery();
  const { data: checkmpin, refetch: refetchmpin } = useCheckMpinStatusQuery();
  const [verifyMpin, { isLoading: isVerifyingMpin }] = useVerifyMpinStatusMutation();
  console.log({ checkmpin: checkmpin?.data });
  const { data: countriesData, isLoading: countriesLoading, isError: countriesError } = useGetCustomerCountriesQuery();
  const [uploadCompose, { isLoading: bulkIsLoading }] = useUploadComposeSMSMutation();
  const [checkSpamKeywords, { data: spamCheckData, isFetching: isCheckingSpam }] = useLazyCheckSpamKeywordsQuery();
  const { data: templatesData, isLoading: templatesLoading, isError: templatesError } =
    useGetTemplateByPrincipalIdQuery(prId, { skip: !prId, refetchOnMountOrArgChange: true });

  // ── ALL EFFECTS UNCHANGED (entity preview shows name + trimmed pe_id) ─────
  useEffect(() => {
    if (principalEntitiesData) setPrincipalEntities(principalEntitiesData.data || []);
  }, [principalEntitiesData]);

  useEffect(() => {
    const list = headersData?.data || [];
    setHeaders(list);
  }, [headersData, prId]);

  useEffect(() => {
    const newSocket = io(socketApi, { transports: ["websocket"], secure: true });
    console.log({ newSocket });
    setSocket(newSocket);
    newSocket.on("connect", () => console.log("Connected to Socket.IO server"));
    newSocket.on("disconnect", () => console.log("Disconnected from Socket.IO server"));
    newSocket.on("sendSMSResponse", (data) => console.log("Received sendSMS response:", data));
    return () => newSocket.disconnect();
  }, []);

  useEffect(() => {
    if (!onPreviewChange) return;
    onPreviewChange({
      // ── NEW: name + trimmed pe_id ──
      entity: entityId?.pe_name
        ? `${entityId.pe_name} (${entityId.pe_id ? trimPeId(entityId.pe_id) : ""})`
        : "",
      senderId: headerName || "",
      templateName: selectedTemplateName || "",
      templateId: templateId || "",
      file: file ? file.name : "",
      additionalNumbers: phoneNumbers ? `${phoneNumbers.split("\n").filter(Boolean).length} numbers` : "",
      message: smstext || "",
      smsType: smsType || "",
      schedule: enableSchedule ? sendTime : "Immediately",
      allowLong: !!isAllow,
      isFlash: !!isFlash,
      charCount: charCountState || 0,
      smsCount: smsCountState || 0,
    });
  }, [entityId, headerName, selectedTemplateName, templateId, file, phoneNumbers, smstext, smsType,
    enableSchedule, sendTime, isAllow, isFlash, charCountState, smsCountState, onPreviewChange]);

  console.log({ socket });

  useEffect(() => { setTemplates(templatesData?.data || []); }, [templatesData, prId]);

  const filteredTemplates = templates.filter((template) =>
    (template.template_name || "")
      .toLowerCase()
      .includes(templateSearch.trim().toLowerCase()),
  );

  // ── ALL HANDLERS UNCHANGED (review entity shows name + trimmed pe_id) ─────
  const handleCountrySelect = (countryId, countryName, countrycode) => {
    const cleanCountryCode = countrycode.trim();
    setSelectedCountry({ id: countryId, name: countryName, code: cleanCountryCode });
    setIsCountrySelected(true);
    const mobileInput = document.getElementById("mobile");
    if (mobileInput && mobileInput.value) {
      const mobileNumber = mobileInput.value.trim();
      if (mobileNumber.startsWith(cleanCountryCode))
        mobileInput.value = mobileNumber.replace(cleanCountryCode, "").trim();
    }
  };

  const checkForUnicodeCharacters = (text) => {
    if (smsType !== "english") return false;
    return getUnicodeCharacters(text).length > 0;
  };

  function getUnicodeCharacters(sentence) {
    const unicodeChars = [];
    for (const char of sentence) {
      const codePoint = char.codePointAt(0);
      if (codePoint > 127) unicodeChars.push({ codePoint, char, code: "U+" + codePoint.toString(16).toUpperCase().padStart(4, "0") });
    }
    const unique = []; const seen = new Set();
    for (const u of unicodeChars) { if (!seen.has(u.char)) { seen.add(u.char); unique.push(u); } }
    return unique;
  }

  const handleSmsTypeChange = (event) => {
    const selectedValue = event.target.value;
    setSmsType(selectedValue);
    if (selectedValue === "other") setSmsText("");
    setSmsText(""); setCharCountState(0); setSmsCountState(0);
    setTemplateId(""); setPeId(""); setIsAllow(false); setCountdownTimer(null);
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
    setFile(event.target.files[0]);
    if (files.length > 0) setFileNames(Array.from(files).map((f) => f.name).join(", "));
    else setFileNames("");
  };

  const handleReviewClick = async () => {
    if (!isPrincipalEntitySelected) { toast.error("Please select a PRINCIPAL ENTITY."); return; }
    if (!headerName) { toast.error("Please select a template to get header name"); return; }
    if (smsType === "english" && checkForUnicodeCharacters(smstext)) {
      toast.error("Unicode characters are not allowed in English SMS. Please remove them or select 'Other SMS' (हिंदी व अन्य भाषाएँ).");
      return;
    }
    const mobileNumberInput = document.getElementById("mobile")?.value.trim() || "";
    if (!mobileNumberInput) { toast.error("Please enter at least one mobile number"); return; }
    try {
      const spamCheck = await checkSpamKeywords(smstext).unwrap();
      if (spamCheck?.status === false && spamCheck?.data?.length > 0) {
        setSpamKeywords(spamCheck.data); setShowSpamWarning(true);
        toast.warn(`Spam keywords found: ${spamCheck.data.join(", ")}`); return;
      }
      const formattedNumbers = mobileNumberInput.split("\n")
        .map((num) => num.replace(selectedCountry.code, "").trim())
        .filter((num) => num !== "").join("\n");
      const previewPayload = {
        phoneList: formattedNumbers,
        customer_id: entityId?.principalentity_id || 0,
        noofdays: filterDatatill_days,
        country_code: selectedCountry.code,
        smsCount: smsCountState || 0,
        charCount: charCountState || 0,
        service_id: service_id || 1,
        country_id: selectedCountry.id || 1,
      };
      const previewResponse = await previewComposeData(previewPayload).unwrap();
      setfilterMobileNumber(previewResponse?.results?.filtered_mobiles)
      console.log("previewResponse", previewResponse?.results?.totalremains);
      const data = {
        // ── NEW: name + trimmed pe_id ──
        entity: entityId?.pe_name
          ? `${entityId.pe_name} (${entityId.pe_id ? trimPeId(entityId.pe_id) : ""})`
          : "Not selected",
        senderId: headerName || "Not selected",
        smsType, smstext,
        templateId: templateId ? maskNumber(templateId) : "None",
        country: `${selectedCountry.name} (${selectedCountry.code})`,
        allowLongMessage: isAllow ? "Yes" : "No",
        isFlash: isFlash ? "Yes" : "No",
        schedule: enableSchedule ? sendTime : "Immediately",
        phoneNumbers: mobileNumberInput || "No numbers entered",
        charCount: charCountState, smsCount: smsCountState,
        spamKeywords: spamCheck?.data || [],
        previewData: previewResponse,
      };
      setReviewData(data); setIsReviewModalOpen(true);
    } catch (error) {
      console.error("Error checking spam keywords:", error);
      toast.error("Failed to check for spam keywords. Please try again.");
    }
  };

  const handleFinalSubmit = async () => {
    try {
    } catch (error) {
      console.error("MPIN Status Error:", error);
      toast.error("Failed to check MPIN status. Proceeding without verification.");
      submitSMS();
    }
  };

  const submitSMS = async () => {
    const currentDateTime = formatedCurrentDateTime();
    setIsSubmit(true);
    const formData = new FormData();
    try {
      const res = await formData;
      if (res?.data?.status) { }
    } catch (error) {
    } finally { setIsSubmittingAfterMpin(false); setIsSubmit(false); }
  };

  const handleEntityChange = (e) => {
    const selectedEntity = e.target.value;
    setEntityId(selectedEntity);
    setPrId(selectedEntity?.principalentity_id || null);
    setIsPrincipalEntitySelected(!!selectedEntity);
    setHeaderName(""); setHeaders([]); setTemplates([]);
    setSmsText(""); setTemplateId(""); setCharCountState(0); setSmsCountState(0);
    setSelectedTemplateName("");
  };

  const handleCountryModalToggle = () => setIsCountryModalOpen(!isCountryModalOpen);

  const transliterateStateChangeHandler = (e) => setIsTransliterationEnabled(e.transliterationEnabled);

  const uniqueCountries = useMemo(() => {
    const list = countriesData?.data || []; const map = new Map();
    list.forEach((item) => {
      const id = Number(item.country_id);
      if (!map.has(id)) map.set(id, { id, name: item?.country?.country_name || "", code: (item?.country?.countrycode || "").trim() });
    });
    return Array.from(map.values());
  }, [countriesData]);

  useEffect(() => {
    const loadTransliterationAPI = () => google.load("elements", "1", { packages: "transliteration", callback: onLoad });
    const script = document.createElement("script");
    script.src = "https://www.google.com/jsapi"; script.onload = loadTransliterationAPI;
    document.body.appendChild(script);
  }, []);

  const onLoad = () => {
    const txtMessageElement = document.getElementById("txtMessage");
    if (!txtMessageElement) { setTimeout(onLoad, 100); return; }
    const options = {
      sourceLanguage: "en",
      destinationLanguage: ["hi", "ar", "bn", "fa", "gu", "kn", "ml", "mr", "ne", "pa", "ta", "te", "ur"],
      transliterationEnabled: false, shortcutKey: "ctrl+g",
    };
    const control = new google.elements.transliteration.TransliterationControl(options);
    setTransliterationControl(control);
    control.makeTransliteratable(["txtMessage"]);
    setIsTransliterationEnabled(control.isTransliterationEnabled());
    setLanguages(google.elements.transliteration.getDestinationLanguages(google.elements.transliteration.LanguageCode.ENGLISH));
    control.addEventListener(google.elements.transliteration.TransliterationControl.EventType.STATE_CHANGED, transliterateStateChangeHandler);
  };

  const checkboxClickHandler = () => {
    if (transliterationControl) {
      transliterationControl.toggleTransliteration();
      const isEnabled = transliterationControl.isTransliterationEnabled();
      setIsTransliterationEnabled(isEnabled);
      if (isEnabled) {
        setCurrentLanguage("hi");
        transliterationControl.setLanguagePair(google.elements.transliteration.LanguageCode.ENGLISH, "hi");
      }
    }
  };

  const languageChangeHandler = (event) => {
    const selectedLang = event.target.value;
    setCurrentLanguage(selectedLang);
    if (transliterationControl)
      transliterationControl.setLanguagePair(google.elements.transliteration.LanguageCode.ENGLISH, selectedLang);
  };

  const handleSmsTextChange = (e) => {
    const text = e.target.value;
    setSmsText(text);
    const trimmedText = text.trimEnd();
    if (smsType === "english") {
      const hasUnicode = checkForUnicodeCharacters(trimmedText);
      if (hasUnicode) {
        const unicodeChars = getUnicodeCharacters(trimmedText);
        const charsList = unicodeChars.map((u) => u.char).join(", ");
        alert(`Unicode characters (${charsList}) are not allowed in English SMS. Please remove them or select "Other SMS" (हिंदी व अन्य भाषाएँ).`);
      }
    }
    let newCharCount = 0;
    const specialSymbols = ["^", "|", "{", "}", "[", "]", "\\", "~"];
    for (let i = 0; i < trimmedText.length; i++) newCharCount += specialSymbols.includes(trimmedText[i]) ? 2 : 1;
    setCharCountState(newCharCount);
    let smsCount = 1;
    if (smsType === "english") { if (newCharCount <= 160) smsCount = 1; else if (newCharCount <= 306) smsCount = 2; else smsCount = Math.ceil(newCharCount / 153); }
    else { if (newCharCount <= 70) smsCount = 1; else if (newCharCount <= 134) smsCount = 2; else smsCount = Math.ceil(newCharCount / 67); }
    setSmsCountState(smsCount);
    if (typeof onPreviewChange === "function") onPreviewChange((prev) => ({ ...prev, message: trimmedText, charCount: newCharCount, smsCount }));
    const singleSmsLimit = smsType === "english" ? 160 : 70;
    if (newCharCount > singleSmsLimit && !isAllow) {
      setIsAllow(true); setIsLongMessageWarning(true);
      if (!alertShown) { alert(`Message exceeds ${singleSmsLimit} characters and will take multiple SMS! "Allow Long Message"`); setAlertShown(true); }
    } else if (newCharCount <= singleSmsLimit && isAllow) { setIsAllow(false); setIsLongMessageWarning(false); }
    else setIsLongMessageWarning(false);
  };

  const handleTemplateSelect = (templateText, templateId, templateName, headerId) => {
    setSmsText(templateText);
    setTemplateId(templateId);
    setSelectedTemplateName(templateName);

    if (headerId) {
      const header = headers.find(h => h.header_id === headerId);
      if (header) setHeaderName(header.header_name);
      else setHeaderName("");
    } else setHeaderName("");

    setIsTemplateModalOpen(false);
    handleSmsTextChange({ target: { value: templateText } });
  };

  console.log({ socket: socket?.connected });

  const handleSubmit = async () => {
    setIsSubmit(true);
    const currentDateTime = formatedCurrentDateTime();
    if (!isPrincipalEntitySelected) { toast.error("Please select a PRINCIPAL ENTITY."); setIsSubmit(false); return; }
    if (!headerName) { toast.error("Please select a template to get header name"); setIsSubmit(false); return; }
    if (enableSchedule) {
      if (dayjs(sendTime).isBefore(dayjs())) { toast.error("Schedule time cannot be in the past"); setIsSubmit(false); return; }
    }
    if (!dateTime) { toast.error("Please select a date and time for the message."); setIsSubmit(false); return; }
    const formData = new FormData();
    formData.append("smstext", (smstext || "").trimEnd());
    formData.append("template_id", templateId || "0");
    formData.append("header_name", headerName || "");
    formData.append("pe_id", entityId.pe_id);
    formData.append("country_id", selectedCountry.id || "");
    formData.append("country_code", selectedCountry.code);
    formData.append("post_via", "compose");
    formData.append("is_flash", isFlash);
    formData.append("language", smsType);
    formData.append("allowLongSms", isAllow);
    formData.append("smsCount", Number(smsCountState));
    formData.append("charCount", charCountState);
    formData.append("service_id", service_id);
    if (enableFilterTill && filterDatatill_days) formData.append("filterdatatill_days", String(filterDatatill_days));
    if (enableSchedule) formData.append("time_to_send", sendTime);
    if (file) formData.append("upload_file", file);
    const mobileNumberInput = document.getElementById("mobile")?.value.trim();
    if (mobileNumberInput && mobileNumberInput !== "") {
      // formData.append("phone_number", filterMobileNumber);
      formData.append("phone_number", filterMobileNumber);
    }
    for (let [key, value] of formData.entries()) console.log(key, value);
    try {
      const res = await uploadCompose(formData).unwrap();
      console.log("Upload response:", res);
      if (res?.status) {
        if (socket && res?.data?.campaign_id) socket.emit("sendSMS", { campaign_id: res.data.campaign_id });
        toast.success("Data uploaded successfully!");
        setIsReviewModalOpen(false); setMpinModalOpen(false); resetForm();
      } else {
        let errorMessage = res?.message || "Submission failed due to content restrictions";
        if (res?.data?.length > 0) errorMessage += `\nDetected spam keywords: ${res.data.join(", ")}`;
        toast.warn(errorMessage);
      }
    } catch (error) {
      setIsSubmit(false);
      if (error.data) {
        let errorMessage = error.data.message || "Submission failed due to content restrictions";
        if (error.data.data?.length > 0) errorMessage += `\nDetected spam keywords: ${error.data.data.join(", ")}`;
        toast.warn(errorMessage);
      } else if (error.response) {
        toast.error(error.response.data.message || "An error occurred while uploading the file.");
      } else toast.error("An error occurred while uploading the file.");
      console.error("API Error:", error);
    }
  };

  const resetForm = () => {
    setPhoneNumbers(""); setFile(null); setEntityId(null); setHeaderName("");
    setTemplates([]); setPrId(null); setEnableSchedule(false); setTemplateId(""); setSmsText("");
    setSmsCount(1); setCharCount(0); setSmsCountState(0); setCharCountState(0);
    setPeId(""); setPostVia(""); setIsFlash(false); setIsAllow(false);
    setSendTime(formatedCurrentDateTime()); setSelectedTemplateName("");
  };

  const handleConfrimSubmit = async () => {
    if (checkmpin?.data?.allow_mpin) setMpinModalOpen(true);
    else handleSubmit();
  };

  const verifyMpinHandler = async () => {
    try {
      const response = await verifyMpin({ mpin_pass: mpin });
      console.log({ response });
      if (response?.data?.status) {
        setMpinModalOpen(false); setIsReviewModalOpen(false);
        setTimeout(async () => { await handleSubmit(); }, 1000);
      } else setMpinError(response.data.message || "Verification failed");
    } catch (error) {
      console.error("MPIN Verification Error:", error);
      if (error.status === 404) toast.error("MPIN verification endpoint not found");
      else if (error.data?.message) setMpinError(error.data.message);
      else setMpinError("Invalid MPIN ");
    }
  };

  if (bulkIsLoading) return <Loader />;

  // ── JSX: UI updated to match BulkSMS, all logic identical ────────────────
  return (
    <>
      {/* ── SMS Language ─────────────────────────────────────────────────── */}
      <Box sx={{ mt: 1 }}>
        <FormControl size="small" sx={{ minWidth: 100 }}>
          <InputLabel id="smsType-label" sx={{ fontSize: "0.8rem" }}>SMS Language</InputLabel>
          <Select
            labelId="smsType-label" id="smsType" value={smsType} label="SMS Language"
            onChange={handleSmsTypeChange}
            MenuProps={compactMenuProps}
            sx={{ ...glassField, "& .MuiSelect-select": { fontSize: "0.8rem" } }}
          >
            <MenuItem value="english" sx={{ fontSize: "0.8rem" }}>English Lang</MenuItem>
            <MenuItem value="other" sx={{ fontSize: "0.8rem" }}>Other Lang</MenuItem>
          </Select>
        </FormControl>
      </Box>

      {/* ── Main Row (compact) ───────────────────────────────────────────── */}
      <Box sx={{ display: "flex", mt: 1.5, gap: 2, alignItems: "flex-start", maxWidth: FORM_MAX_WIDTH }}>

        {/* Left Column — flexible, fixed-width controls */}
        <Stack
          direction="row"
          sx={{
            flex: 1,
            minWidth: 0,
            gap: 1.5,
            alignItems: "flex-start",
            flexWrap: "wrap",
          }}
        >
          {/* Entity dropdown — 190px, name + trimmed pe_id, with renderValue so pe_id stays visible */}
          <FormControl sx={{ width: 190 }}>
            <InputLabel id="entityId-label" sx={{ fontSize: "0.8rem" }}>Entity Id</InputLabel>
            <Select
              labelId="entityId-label" id="entityId-label" label="Entity Id"
              value={entityId} onChange={handleEntityChange} size="medium"
              MenuProps={compactMenuProps}
              sx={glassField}
              /* pe_name truncates with ellipsis, but pe_id stays visible to its last digit */
              renderValue={(selected) => {
                if (!selected?.pe_id) return "Select Entity Id";
                return (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      minWidth: 0,
                      fontSize: "0.8rem",
                    }}
                  >
                    <Box
                      sx={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        minWidth: 0,
                      }}
                    >
                      {selected.pe_name}
                    </Box>
                    <Box sx={{ flexShrink: 0, whiteSpace: "nowrap" }}>
                      ({trimPeId(selected.pe_id)})
                    </Box>
                  </Box>
                );
              }}
            >
              <MenuItem value="" sx={{ fontSize: "0.8rem" }}>Select Entity Id</MenuItem>
              {isLoading ? (
                <MenuItem disabled sx={{ fontSize: "0.8rem" }}>Loading...</MenuItem>
              ) : isError ? (
                <MenuItem disabled sx={{ fontSize: "0.8rem" }}>No Entities Available</MenuItem>
              ) : principalEntities.length > 0 ? (
                principalEntities.map((entity, index) => (
                  <MenuItem key={index} value={entity} sx={{ fontSize: "0.8rem" }}>
                    {/* ── NEW: name + trimmed pe_id ── */}
                    {entity.pe_name} ({trimPeId(entity.pe_id)})
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled sx={{ fontSize: "0.8rem" }}>No Entities Available</MenuItem>
              )}
            </Select>
          </FormControl>

          {/* Filter From LC + Filter Till */}
          {checkmpin?.data?.allow7_day_filter && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
                height: FIELD_HEIGHT,
              }}
            >
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    checked={enableFilterTill}
                    onChange={(e) => {
                      setEnableFilterTill(e.target.checked);
                      if (!e.target.checked) setFilterDatatill_days(0);
                    }}
                  />
                }
                label="Filter From LC"
                sx={{ m: 0, "& .MuiFormControlLabel-label": { fontSize: "0.75rem", color: "#000" } }}
              />
              {enableFilterTill && (
                <FormControl size="small" sx={{ width: 130 }}>
                  <InputLabel sx={{ fontSize: "0.7rem" }}>Filter Till</InputLabel>
                  <Select
                    value={filterDatatill_days}
                    label="Filter Till"
                    onChange={(e) => setFilterDatatill_days(e.target.value)}
                    MenuProps={compactMenuProps}
                    sx={{
                      fontSize: "0.75rem",
                      height: 28,
                      background: "rgba(255,255,255,0.7)",
                      backdropFilter: "blur(8px)",
                      borderRadius: "6px",
                    }}
                  >
                    <MenuItem value={1} sx={{ fontSize: "0.75rem" }}>Today</MenuItem>
                    <MenuItem value={2} sx={{ fontSize: "0.75rem" }}>Yesterday</MenuItem>
                    {Array.from({ length: 28 }, (_, i) => i + 3).map((d) => (
                      <MenuItem key={d} value={d} sx={{ fontSize: "0.75rem" }}>Last {d} days</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </Box>
          )}

          {/* Mobile Numbers */}
          <TextField
            id="mobile"
            multiline
            rows={2}
            label="Mobile Numbers"
            placeholder="Enter Mobile Numbers (one per line)"
            value={phoneNumbers}
            onChange={(e) => setPhoneNumbers(e.target.value.replace(/[^0-9\n]/g, ""))}
            sx={{
              width: 220,
              "& .MuiOutlinedInput-root": {
                fontSize: "0.8rem",
                background: "rgba(255,255,255,0.7)",
              },
              "& .MuiInputLabel-root": { fontSize: "0.8rem" },
            }}
          />
        </Stack>
      </Box>

      {/* ── Message Area ─────────────────────────────────────────────────── */}
      <Box sx={{ mt: 1.5 }}>
        {smsType === "other" && (
          <Box sx={{ mb: 1 }}>
            <FormControlLabel
              control={<Checkbox checked={isTransliterationEnabled} onChange={checkboxClickHandler} sx={{ p: 0.5 }} />}
              label="Enable Text Editor:"
              componentsProps={{ typography: { fontSize: "0.75rem", color: "#000" } }}
            />
            {isTransliterationEnabled && (
              <Select
                onChange={languageChangeHandler}
                disabled={!isTransliterationEnabled}
                size="small"
                label="Language"
                value={currentLanguage}
                MenuProps={compactMenuProps}
                sx={{ minWidth: 30, ml: 1, fontSize: "0.7rem", background: "rgba(255,255,255,0.7)", borderRadius: "6px" }}
              >
                {Object.entries(languages).map(([key, value]) => (
                  <MenuItem key={value} value={value} sx={{ fontSize: "0.7rem" }}>{key}</MenuItem>
                ))}
              </Select>
            )}
          </Box>
        )}

        {selectedTemplateName && (
          <Typography variant="subtitle2" sx={{ fontSize: "0.75rem", color: "#666", fontWeight: "bold", mb: 0.5 }}>
            Template Name: {selectedTemplateName}
          </Typography>
        )}

        <TextField
          label="Message"
          id="txtMessage" value={smstext} onChange={handleSmsTextChange} name="txtMessage"
          multiline rows={3}
          placeholder={smsType === "other" ? "70 Character Message Enter" : "160 Character Message Enter"}
          variant="outlined" margin="normal"
          sx={{
            width: "100%",
            maxWidth: FORM_MAX_WIDTH,
            m: 0,
            "& .MuiOutlinedInput-root": { background: "rgba(255,255,255,0.7)", backdropFilter: "blur(8px)" },
          }}
          helperText={
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mt: 0.75 }}>
              <Button size="small" variant="contained" color="primary"
                onClick={() => setIsTemplateModalOpen(true)}
                sx={{ textTransform: "none", fontSize: "0.7rem", px: 1, py: 0.5 }}>
                Open Template
              </Button>
              <Box sx={{ fontSize: "0.7rem", color: "text.secondary" }}>
                SMS Count: {smsCountState} | Char Count: {charCountState}
              </Box>
              <FormControlLabel
                control={
                  <Checkbox id="allowLongMsg" checked={isAllow} onChange={(e) => setIsAllow(e.target.checked)} size="small" sx={{ p: 0.5 }} />
                }
                label="Allow Long Message"
                sx={{ m: 0, "& .MuiFormControlLabel-label": { fontSize: "0.7rem", color: "#000" } }}
              />
            </Box>
          }
          FormHelperTextProps={{ sx: { margin: 0 } }}
        />
      </Box>

      {/* ── Flash & Schedule ─────────────────────────────────────────────── */}
      <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2, mt: 1.5 }}>
        <FormControlLabel
          control={<Checkbox checked={isFlash} onChange={(e) => setIsFlash(e.target.checked)} size="small" sx={{ p: 0.5 }} />}
          label="Is Flash"
          sx={{ m: 0, "& .MuiFormControlLabel-label": { fontSize: "0.8rem", color: "#000" } }}
        />
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FormControlLabel
            control={
              <Checkbox checked={enableSchedule} size="small" sx={{ p: 0.5 }}
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  setEnableSchedule(isChecked);
                  if (!isChecked) {
                    const now = dayjs().format("YYYY-DD-MM HH:mm");
                    setDateTime(now); setSendTime(now);
                  } else {
                    setMinDateTime(dayjs().format("YYYY-DD-MMTHH:mm"));
                  }
                }}
              />
            }
            label="Schedule For Later?"
            sx={{ m: 0, "& .MuiFormControlLabel-label": { fontSize: "0.8rem", color: "#000" } }}
          />
          {enableSchedule && (
            <TextField
              id="dateTime" label="Schedule Date" type="datetime-local" value={sendTime}
              onChange={(e) => {
                const selectedDateTime = e.target.value;
                const now = dayjs().format("YYYY-MM-DDTHH:mm");
                if (dayjs(selectedDateTime).isBefore(now)) { toast.error("Schedule time cannot be in the past"); setSendTime(now); }
                else setSendTime(selectedDateTime);
              }}
              size="small" InputLabelProps={{ shrink: true }} inputProps={{ min: minDateTime }}
              sx={{
                width: 200,
                "& .MuiInputBase-root": { fontSize: "0.8rem", background: "rgba(255,255,255,0.7)" },
                "& .MuiInputLabel-root": { fontSize: "0.8rem" },
              }}
            />
          )}
        </Box>
      </Box>

      {/* ── Country & Preview ────────────────────────────────────────────── */}
      <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 2, mt: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", fontSize: "0.8rem" }}>
          <label className="block font-medium text-[0.8rem]">Select Country</label>
          <Box sx={{ ml: 1.5 }}>
            {selectedCountry ? (
              <span className="text-blue-500 cursor-pointer underline" onClick={handleCountryModalToggle}>
                {selectedCountry.name} ({selectedCountry.code})
              </span>
            ) : (
              <button onClick={handleCountryModalToggle} className="text-blue-500 underline">Select Country</button>
            )}
          </Box>

          {isCountryModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
              <div className="bg-white p-6 rounded-lg max-w-sm w-full relative">
                <h2 className="text-xl font-semibold mb-4 text-[0.8rem]">Select Country</h2>
                <button onClick={() => setIsCountryModalOpen(false)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-800">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
                {countriesLoading ? <p>Loading countries...</p>
                  : countriesError ? <p>No countries available</p>
                    : (
                      <div className="max-h-96 overflow-y-auto">
                        {countriesData?.data?.length > 0 ? (
                          uniqueCountries.map((country) => (
                            <div key={country.id}
                              onClick={() => handleCountrySelect(country.id, country.name, country.code)}
                              className={`p-3 mb-2 cursor-pointer rounded hover:bg-gray-100 ${selectedCountry?.id === country.id ? "bg-blue-100" : ""}`}>
                              {country.name} ({country.code})
                            </div>
                          ))
                        ) : <p>No countries available</p>}
                      </div>
                    )}
              </div>
            </div>
          )}
        </Box>

        <Button variant="outlined" color="primary" size="medium" onClick={handleReviewClick}
          sx={{ textTransform: "none", fontSize: "0.8rem", px: 2 }}>
          Preview
        </Button>
      </Box>

      {/* ── Review Modal ─────────────────────────────────────────────────── */}
      {isReviewModalOpen && (
        <Dialog open={isReviewModalOpen} onClose={() => setIsReviewModalOpen(false)} fullWidth maxWidth="md">
          <DialogTitle>Review Your SMS Details</DialogTitle>
          <DialogContent dividers>
            {isPreviewLoading ? (
              <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: 200 }}>
                <CircularProgress />
                <Typography sx={{ ml: 2 }}>Loading preview data...</Typography>
              </Box>
            ) : (
              <>
                {reviewData?.previewData?.results && (
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="h6" gutterBottom>Processing Results</Typography>
                    <Grid container spacing={1}>
                      {[
                        { label: "Total Posted", value: reviewData.previewData.results?.totalposted },
                        { label: "Total Remains", value: reviewData.previewData.results?.totalremains },
                        { label: "Last Campaign Filter", value: reviewData.previewData.results?.totalsevendaysfilter },
                        { label: "Global Blacklist", value: reviewData.previewData.results?.totalglobalblacklist },
                        { label: "Customer Blacklist", value: reviewData.previewData.results?.totalcustomerblacklist },
                        { label: "Duplicates", value: reviewData.previewData.results?.totalduplicates },
                        { label: "Estimated Cost", value: reviewData.previewData.results?.total_cost },
                      ].map(({ label, value }) => (
                        <Grid key={label} item xs={6} md={2}>
                          <Paper variant="outlined" sx={{ p: 0.75, borderRadius: 1.5, textAlign: "center" }}>
                            <Typography variant="caption" color="text.secondary" display="block">{label}</Typography>
                            <Typography variant="body2" fontWeight="bold">{value ?? "-"}</Typography>
                          </Paper>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}

                {reviewData?.previewData?.results?.message && (
                  <Box sx={{ mb: 2, textAlign: "center" }}>
                    <Typography
                      component="strong"
                      sx={{
                        color: reviewData?.previewData?.results?.is_campaign_ready === "yes" ? "success.main" : "error.main",
                        fontWeight: "bold",
                      }}
                    >
                      {reviewData?.previewData?.results?.message}
                    </Typography>
                  </Box>
                )}

                {reviewData?.spamKeywords?.length > 0 && (
                  <Box sx={{ backgroundColor: "#fff3cd", color: "#856404", p: 2, borderRadius: 1, mb: 2 }}>
                    <Typography variant="subtitle1" fontWeight="bold">Warning: Spam Keywords Detected</Typography>
                    <Typography variant="body2">The following keywords may trigger spam filters: {reviewData.spamKeywords.join(", ")}</Typography>
                  </Box>
                )}
                <Box>
                  <Typography variant="h6" gutterBottom>SMS Details</Typography>
                  <Grid container spacing={2}>
                    {[
                      { label: "Entity", value: reviewData?.entity },
                      { label: "Header Name", value: reviewData?.senderId },
                      { label: "SMS Type", value: reviewData?.smsType === "english" ? "English" : "Other Languages" },
                      { label: "Message", value: <Box sx={{ whiteSpace: "pre-wrap" }}>{reviewData?.smstext}</Box> },
                      { label: "Filter Days", value: filterDatatill_days || "0" },
                      { label: "Allow Long Message", value: reviewData?.allowLongMessage || (isAllow ? "Yes" : "No") },
                      { label: "Is Flash", value: reviewData?.isFlash || (isFlash ? "Yes" : "No") },
                      { label: "Message Stats", value: `${reviewData?.charCount} characters | ${reviewData?.smsCount} SMS` },
                    ].map(({ label, value }) => (
                      <Grid key={label} item xs={12} md={4}>
                        <Paper variant="outlined" sx={{ p: 1, borderRadius: 2 }}>
                          <Typography variant="body2" color="text.secondary">{label}</Typography>
                          <Typography variant="subtitle2" fontWeight="bold">{value ?? "-"}</Typography>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsReviewModalOpen(false)}>Edit</Button>
            <Button variant="contained" color="primary" onClick={handleConfrimSubmit}
              disabled={isPreviewLoading || !reviewData?.previewData?.results?.totalremains || reviewData?.previewData?.results?.is_campaign_ready !== "yes"}>
              {isPreviewLoading ? <CircularProgress size={20} /> : "Confirm & Submit"}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {/* ── MPIN Modal ───────────────────────────────────────────────────── */}
      <Dialog open={mpinModalOpen} onClose={() => setMpinModalOpen(false)}>
        <DialogTitle>Enter MPIN</DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>MPIN verification is required to proceed</Typography>
          <TextField autoFocus margin="dense" label="Enter MPIN" type="password" fullWidth variant="outlined"
            value={mpin} onChange={(e) => { setMpin(e.target.value); setMpinError(""); }}
            error={!!mpinError} helperText={mpinError} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setMpinModalOpen(false); setIsSubmittingAfterMpin(false); }}>Cancel</Button>
          <Button onClick={verifyMpinHandler} color="primary" disabled={isVerifyingMpin}>
            {isVerifyingMpin ? <CircularProgress size={24} /> : "Verify"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ── Template Modal ───────────────────────────────────────────────── */}
      {isTemplateModalOpen && (
        <Dialog
          open={isTemplateModalOpen}
          onClose={() => {
            setIsTemplateModalOpen(false);
            setTemplateSearch("");
          }}
        >
          <DialogTitle sx={{ fontSize: "0.75rem", fontWeight: "bold", pb: 0.5 }}>Select Template</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              size="small"
              label="Search template by name"
              value={templateSearch}
              onChange={(e) => setTemplateSearch(e.target.value)}
              sx={{ mb: 1.5 }}
            />
            {templatesLoading ? <CircularProgress />
              : templatesError ? <Typography color="error">Error loading templates</Typography>
                : filteredTemplates.length > 0 ? (
                  <List sx={{ backgroundColor: "#fff", p: 0 }}>
                    {filteredTemplates.map((template) => (
                      <ListItem button key={template.template_id}
                        sx={{ mb: 1, backgroundColor: "#fff", border: "1px solid #e0e0e0", borderRadius: 1, "&:hover": { backgroundColor: "#f5f5f5" } }}
                        onClick={() => {
                          handleTemplateSelect(
                            template.template_text,
                            template.trai_template_id,
                            template.template_name,
                            template.header_id
                          );
                        }}>
                        <ListItemText
                          primary={
                            <>
                              <span style={{ fontSize: "0.75rem", fontWeight: "bold" }}>
                                Template Name: {template.template_name}
                              </span>
                              <br />
                              <span style={{ fontSize: "0.75rem" }}>{template.template_text}</span>
                            </>
                          }
                          secondary={
                            <>
                              <span style={{ fontSize: "0.7rem" }}>ID: {maskNumber(template.trai_template_id)}</span>
                              {template.header_id && (
                                <>
                                  <br />
                                  <span style={{ fontSize: "0.7rem", color: "#1976d2" }}>
                                    Header: {headers.find(h => h.header_id === template.header_id)?.header_name || "Unknown"}
                                  </span>
                                </>
                              )}
                            </>
                          }
                        />
                      </ListItem>
                    ))}
                  </List>
                ) : <Typography>{templateSearch ? "No templates match your search" : "No templates available"}</Typography>}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { setIsTemplateModalOpen(false); setTemplateSearch(""); }}>Close</Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default Compose;